module.exports = __webpack_public_path__ + "media/images/weather/99_night_g-a3769b9873b144f200c8c20a34b1960e.png";